import moment from 'moment'

const getFilledFilters = ({ filters, dateFields = null }) => {
  if (!dateFields) {
    return Object.fromEntries(Object.entries(filters).filter(([_, value]) => value !== undefined && value !== ''))
  }

  return Object.fromEntries(
    Object.entries(filters).filter(([_, value]) => value !== undefined && value !== '').map(([key, value]) => {
      if (dateFields.includes(key) && moment.isMoment(value)) {
        return [key, value.tz(moment.tz.guess()).format()]
      }
      return [key, value]
    }),
  )
}

export { getFilledFilters }
